export var getPreloaderColor = function (_a) {
    var variant = _a.variant, isDarkTheme = _a.isDarkTheme;
    if (variant) {
        if (variant === 'accent') {
            return isDarkTheme ? 'rich-grey' : 'white';
        }
        if (variant === 'main') {
            return isDarkTheme ? 'light-green' : 'white';
        }
        if (variant === 'interface') {
            return isDarkTheme ? 'white' : 'rich-grey';
        }
        if (variant === 'remove') {
            return 'red';
        }
    }
    return 'grey';
};
